import script from "./SimpleGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleGallery.vue?vue&type=script&setup=true&lang=js"

import "./SimpleGallery.vue?vue&type=style&index=0&id=8ab4b368&lang=less"

const __exports__ = script;

export default __exports__